import { registerSem } from '../registry';

// Handler for artifact.persisted event
//
// This registration is REQUIRED even though it returns null. Without it, the event
// type won't be recognized by the registry and won't reach the switch statement in
// useChatStream.ts where the actual handling occurs.
//
// We handle it in the switch statement (rather than here) because we need to:
// 1. Ensure the related editable_summary entity exists (keyed by item_id / stableId)
// 2. Use timeline + summaryUi actions together (requires convId + dispatch here)
registerSem('artifact.persisted', () => {
  return null; // Actual handling in useChatStream.ts switch statement
});
